import { render } from "./AppInstall.vue?vue&type=template&id=3413133a&scoped=true&ts=true"
import script from "./AppInstall.vue?vue&type=script&lang=ts"
export * from "./AppInstall.vue?vue&type=script&lang=ts"

import "./AppInstall.vue?vue&type=style&index=0&id=3413133a&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3413133a"]])

export default __exports__